<nz-page-header nzBackIcon [nzGhost]="false">
  <nz-page-header-title i18n>Models</nz-page-header-title>
  <nz-page-header-subtitle i18n>Update and manage inspection models</nz-page-header-subtitle>
  <nz-page-header-extra>
    <nz-space>
      <nz-upload *nzSpaceItem [(nzFileList)]="uploadedFiles" [nzAction]="state.uploadUrl" [nzCustomRequest]="uploadModel" [nzDisabled]="!isAdmin()">
        <button nz-button nzType="primary" [disabled]="!isAdmin()">
          <span nz-icon nzType="upload"></span>
          <span i18n>Upload Model</span>
        </button>
      </nz-upload>
    </nz-space>
  </nz-page-header-extra>
</nz-page-header>

<nz-table [nzData]="state.all" nzTableLayout="fixed">
  <thead>
    <tr>
      <th nzWidth="80px" i18n>Edit</th>
      <th nzWidth="220px" i18n>ID</th>
      <th nzWidth="150px" i18n>Version</th>
      <th nzWidth="80px" i18n>Active</th>
      <th nzWidth="100px" i18n>Using ΔE</th>
      <th nzWidth="100px" i18n>Max CI</th>
      <th nzWidth="80px">dE</th>
      <th nzWidth="80px">dC</th>
      <th nzWidth="80px">xdE</th>
      <th nzWidth="250px" i18n>In a Bucket</th>
      <th nzWidth="250px" i18n>Across Buckets</th>
      <th i18n>Description</th>
      <th nzWidth="90px" i18n>Actions</th>
    </tr>
  </thead>
  <tbody>
    @for (model of state.all; track model.id) {
      <tr>
        <td>
          <button nz-button nzType="default" nzSize="small" [disabled]="!canEditModel()" (click)="openEdit(model)">
            <span nz-icon nzType="edit"></span>
            <span i18n>Edit</span>
          </button>
        </td>
        <td><span class="cell-mono">{{ model.id }}</span></td>
        <td><span class="cell-mono">{{ model.version }}</span></td>
        <td><span nz-icon [nzType]="model.isActive ? 'check-circle' : 'close-circle'" [style.color]="model.isActive ? '#52c41a' : '#ff4d4f'"></span></td>
        <td><span nz-icon [nzType]="model.isUsingDeltaE ? 'check-circle' : 'close-circle'" [style.color]="model.isUsingDeltaE ? '#52c41a' : '#ff4d4f'"></span></td>
        <td>{{ model.maxCi4ReliablePrediction }}</td>
        <td>{{ model.deThreshold }}</td>
        <td>{{ model.dcThreshold }}</td>
        <td>{{ model.xdeThreshold }}</td>
        <td>
          <table class="threshold-table">
            <tr class="header-row">
              <th></th>
              <th i18n>Max</th>
              <th i18n>Min</th>
            </tr>
            <tr>
              <td>ΔL</td>
              <td>{{ model.dlMaxThreshold }}</td>
              <td>{{ model.dlMinThreshold }}</td>
            </tr>
            <tr>
              <td>ΔA</td>
              <td>{{ model.daMaxThreshold }}</td>
              <td>{{ model.daMinThreshold }}</td>
            </tr>
            <tr>
              <td>ΔB</td>
              <td>{{ model.dbMaxThreshold }}</td>
              <td>{{ model.dbMinThreshold }}</td>
            </tr>
          </table>
        </td>
        <td>
          <table class="threshold-table">
            <tr class="header-row">
              <th></th>
              <th i18n>Max</th>
              <th i18n>Min</th>
            </tr>
            <tr>
              <td>ΔL</td>
              <td>{{ model.crossDLMaxThreshold }}</td>
              <td>{{ model.crossDLMinThreshold }}</td>
            </tr>
            <tr>
              <td>ΔA</td>
              <td>{{ model.crossDAMaxThreshold }}</td>
              <td>{{ model.crossDAMinThreshold }}</td>
            </tr>
            <tr>
              <td>ΔB</td>
              <td>{{ model.crossDBMaxThreshold }}</td>
              <td>{{ model.crossDBMinThreshold }}</td>
            </tr>
          </table>
        </td>
        <td><span class="cell-description">{{ model.description }}</span></td>
        <td style="padding:0;">
          <div style="display:flex; gap:4px; align-items:center; justify-content:center; height:100%; padding:4px 8px;">
          <button
            nz-button
            nzType="dashed"
            nzShape="circle"
            nzSize="default"
            [disabled]="!isAdmin()"
            (click)="window.open(state.getDownloadUrl(model.id), '_blank')"
            title="Download"
          >
            <span nz-icon nzType="download"></span>
          </button>
          <button
            nz-button
            nzType="dashed"
            nzShape="circle"
            nzSize="default"
            [disabled]="!canViewJson()"
            (click)="openJsonPreview(model)"
            title="View JSON"
          >
            <span nz-icon nzType="code"></span>
          </button>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-json-object-preview
  [data]="previewModel()"
  [title]="previewModelTitle()"
  (closed)="previewModel.set(null)"
></app-json-object-preview>

<app-inspection-model-edit
  [model]="editingModel()"
  (saved)="onSaved()"
  (cancelled)="onCancelled()"
></app-inspection-model-edit>
